export default "__VITE_ASSET__b515cd26__"